export enum ViewMode {
  UPSERT = 'UPSERT',
  DASHBOARD = 'DASHBOARD'
}
